import React from 'react';

/**
 * This screen template renders the screen descriptor with no decoration.
 * 
 * It supports the 'isReady' prop because this template is used to pre-render 
 * screens to extract their info data before the actual template is ready to go.
 * It will hide all of it's children from the user until this condition is met.
 */
export default function Blank({children, isReady}) {
	return (
		<div style={!isReady ? {visibility:'hidden'} : null}>{ children }</div>
	);
}